import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export function IconBigPauseButton({ classProps }: PropsWithClassProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      className={classProps?.root}
    >
      <g filter="url(#filter0_b_9061_137292)">
        <rect x="1" y="1" width="48" height="48" rx="24" fill="#181818" fillOpacity="0.7" />
        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#545458" strokeOpacity="0.65" />
        <path
          d="M21.9218 16.5H17.7568C17.0627 16.5 16.5 17.0627 16.5 17.7568V32.2432C16.5 32.9373 17.0627 33.5 17.7568 33.5H21.9218C22.6159 33.5 23.1786 32.9373 23.1786 32.2432V17.7568C23.1786 17.0627 22.6159 16.5 21.9218 16.5Z"
          fill="white"
        />
        <path
          d="M32.2433 16.5H28.0783C27.3841 16.5 26.8215 17.0627 26.8215 17.7568V32.2432C26.8215 32.9373 27.3841 33.5 28.0783 33.5H32.2433C32.9374 33.5 33.5 32.9373 33.5 32.2432V17.7568C33.5 17.0627 32.9374 16.5 32.2433 16.5Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_9061_137292"
          x="-23.5"
          y="-23.5"
          width="97"
          height="97"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9061_137292" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9061_137292" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
